<template>
	<div style="width: 100%;display: flex;height: 100%;">
		<input @blur="iptChange" style="width: 36px;border: solid 1px #d5d5d5 ;padding: 0px;min-height: 44px;" v-model.number="selectdItem.compontChildren[0].data.num"/>
		<div  style="display: flex;flex-direction: column;height: 100%;justify-content: space-between;">
			<div @click="add" class="chg" style="display: flex;align-items: center;justify-content: center;border: solid 1px #d5d5d5 ;cursor: pointer;padding: 2px;height: 49%;">
				<i class="el-icon-arrow-up"></i>
			</div>
			<div @click="sub" class="chg" style="display: flex;align-items: center;justify-content: center;border: solid 1px #d5d5d5 ;cursor: pointer;padding: 2px;height: 49%;">
				<i class="el-icon-arrow-down"></i>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	export default {
		props: {
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		mounted() {
			this.setNum({
				num:this.selectdItem.compontChildren[0].data.num
			})
		},
		data() {
			return {
				num:0
			}
		},
		methods:{
			...mapMutations("lowCodeStore", ["setNum"]),
			add() {
				this.selectdItem.compontChildren[0].data.num = this.selectdItem.compontChildren[0].data.num + 1
				this.setNum({
					num:this.selectdItem.compontChildren[0].data.num
				})
			},
			sub() {
				if(this.selectdItem.compontChildren[0].data.num - 1) {
					this.selectdItem.compontChildren[0].data.num  = this.selectdItem.compontChildren[0].data.num - 1
					this.setNum({
						num:this.selectdItem.compontChildren[0].data.num
					})
				}else{
					return
				}
			},
			iptChange() {
				let num = parseInt(this.selectdItem.compontChildren[0].data.num)
				if(!num) {
					this.selectdItem.compontChildren[0].data.num = 1
				}
			}
		}
	}
</script>

<style scoped>
	.chg:active {
		background-color: #c8c8c8 ;
	}
</style>